export const pl = {
    REQUIRED_ACTION_KeepCapturing: 'Kontynuuj przechwytywanie.',
    REQUIRED_ACTION_PauseCapturing: 'Wstrzymaj przechwytywanie',
    REQUIRED_ACTION_Close: 'Zamknij',
    REQUIRED_ACTION_Error: 'Błąd',
    REQUIRED_ACTION_AGREE: 'Zgadzam się',
    REQUIRED_ACTION_DISAGREE: 'Nie zgadzam się',
    LIVENESS_ACTION_Smile: 'Uśmiech',
    LIVENESS_ACTION_Frown: 'Zmarszczyć brwi',
    'LIVENESS_ACTION_Tilt Left': 'Spójrz w lewo.',
    'LIVENESS_ACTION_Tilt Right': 'Spójrz w prawo.',
    'LIVENESS_ACTION_Tilt Up': 'Spójrz w górę.',
    'LIVENESS_ACTION_Tilt Down': 'Spójrz w dół.',
    'LIVENESS_ACTION_Look Straight': 'Patrz prosto przed siebie.',
    'LIVENESS_ACTION_No Action': 'Brak działania',
    LIVENESS_ACTION_PROCESSING_LIVENESS: 'Czas przetwarzania',
    'LIVENESS_RESULT_Thank you!.Failed': 'Niepowodzenie',
    'LIVENESS_RESULT_Thank you!.Passed': 'Zatwierdzono',
    'LIVENESS_RESULT_Thank you!.ActionTimedOut':
        'Akcja przekroczyła limit czasu.',
    'LIVENESS_RESULT_Thank you!.Interrupted': 'Przerwany',
    'LIVENESS_RESULT_Thank you!.Undefined': 'Nieokreślony.',
    LIVENESS_ACTION_LOOK_STRAIGHT_TITLE: 'Patrz prosto przed siebie',
    LIVENESS_ACTION_LOOK_STRAIGHT_TEXT:
        'Nie spuszczaj wzroku z ekranu przez cały czas.',
    LIVENESS_ACTION_LOOK_LEFT_TITLE: 'Obróć głowę lekko w lewo',
    LIVENESS_ACTION_LOOK_LEFT_TEXT:
        'Nie spuszczaj wzroku z ekranu przez cały czas',
    LIVENESS_ACTION_LOOK_RIGHT_TITLE: 'Obróć głowę lekko w prawo',
    LIVENESS_ACTION_LOOK_RIGHT_TEXT:
        'Nie spuszczaj wzroku z ekranu przez cały czas',
    LIVENESS_ACTION_LOOK_UP_TITLE: 'Obróć głowę lekko do góry',
    LIVENESS_ACTION_LOOK_UP_TEXT:
        'Nie spuszczaj wzroku z ekranu przez cały czas',
    LIVENESS_ACTION_LOOK_DOWN_TITLE: 'Obróć głowę lekko w dół',
    LIVENESS_ACTION_LOOK_DOWN_TEXT:
        'Nie spuszczaj wzroku z ekranu przez cały czas',
    LIVENESS_ACTION_SMILE_TITLE: 'Uśmiechnij się',
    LIVENESS_ACTION_SMILE_TEXT: 'Nie spuszczaj wzroku z ekranu przez cały czas',
    LIVENESS_ACTION_FROWN_TITLE: 'Marszczyć brwi',
    LIVENESS_ACTION_FROWN_TEXT: 'Patrz cały czas na ekran',
    PASSIVE_LIVENESS_ERROR_FACE_TOO_CLOSE_TITLE: 'Ojej...Jesteś za blisko.',
    PASSIVE_LIVENESS_ERROR_FACE_CLOSE_TO_BORDER_TITLE:
        'Ojej...Jesteś za blisko.',
    PASSIVE_LIVENESS_ERROR_FACE_CROPPED_TITLE:
        'Coś poszło nie tak. Spróbuj ponownie.',
    PASSIVE_LIVENESS_ERROR_FACE_CROPPED:
        'Coś poszło nie tak. Spróbuj ponownie.',
    PASSIVE_LIVENESS_ERROR_FACE_NOT_FOUND_TITLE:
        'Nie możemy wykryć twarzy na obrazie. Spróbuj ponownie.',
    PASSIVE_LIVENESS_ERROR_FACE_TOO_SMALL_TITLE: 'Ojej...Jesteś za daleko.',
    PASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE_TITLE:
        'Ojej...Coś poszło nie tak.',
    ASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE:
        'Coś poszło nie tak. Spróbuj ponownie.',
    PASSIVE_LIVENESS_ERROR_TOO_MANY_FACES:
        'Nie możemy wykryć twarzy na obrazie. Spróbuj ponownie.',
    PASSIVE_LIVENESS_ERROR_FACE_IS_OCCLUDED_TITLE:
        'Ojej... Nie możemy wykryć twarzy.',
    PASSIVE_LIVENESS_ERROR_UNKNOWN_TITLE: 'Ojej... Coś poszło nie tak.',
    PASSIVE_LIVENESS_ERROR_UNKNOWN: 'Coś poszło nie tak. Spróbuj ponownie.',
    PASSIVE_LIVENESS_ERROR_INTERNAL_TITLE: 'Ojej... Coś poszło nie tak.',
    PASSIVE_LIVENESS_ERROR_INTERNAL: 'Coś poszło nie tak. Spróbuj ponownie.',
    PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD_TITLE: 'Ojej... Coś poszło nie tak.',
    PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD:
        'Coś poszło nie tak. Spróbuj ponownie.',
    PASSIVE_LIVENESS_ERROR_None_TITLE: 'Ojej... Coś poszło nie tak.',
    PASSIVE_LIVENESS_ERROR_None: 'Coś poszło nie tak. Spróbuj ponownie.',
    PASSIVE_LIVENESS_ERROR_FailedExpressions_TITLE:
        'Ojej... Coś poszło nie tak.',
    PASSIVE_LIVENESS_ERROR_FailedExpressions:
        'Coś poszło nie tak. Spróbuj ponownie.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_IMAGE_TITLE:
        'Ojej... Coś poszło nie tak.',
    PASSIVE_LIVENESS_ERROR_IMAGE_ERROR_TITLE: 'Ojej... Coś poszło nie tak.',
    PASSIVE_LIVENESS_ERROR_IMAGE_ERROR: 'Coś poszło nie tak. Spróbuj ponownie.',
    PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR_TITLE: 'Ojej... Coś poszło nie tak.',
    PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR:
        'Coś poszło nie tak. Spróbuj ponownie.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE_TITLE:
        'Ojej... Coś poszło nie tak.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE:
        'Coś poszło nie tak. Spróbuj ponownie.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL_TITLE:
        'Ojej... Coś poszło nie tak.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL:
        'Coś poszło nie tak. Spróbuj ponownie.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE_TITLE:
        'Ojej... Coś poszło nie tak.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE:
        'Coś poszło nie tak. Spróbuj ponownie.',
    PASSIVE_LIVENESS_ERROR_INVALID_CONFIG_TITLE: 'Ojej... Coś poszło nie tak.',
    PASSIVE_LIVENESS_ERROR_INVALID_CONFIG:
        'Coś poszło nie tak. Spróbuj ponownie.',
    PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD_TITLE:
        'Ojej... Coś poszło nie tak.',
    PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD:
        'Coś poszło nie tak. Spróbuj ponownie.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT_TITLE:
        'Ojej... Coś poszło nie tak.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT:
        'Coś poszło nie tak. Spróbuj ponownie.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT_TITLE:
        'Ojej... Coś poszło nie tak.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT:
        'Coś poszło nie tak. Spróbuj ponownie.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS_TITLE:
        'Ojej... Coś poszło nie tak.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS:
        'Coś poszło nie tak. Spróbuj ponownie.',
    PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE_TITLE:
        'Ojej... Coś poszło nie tak.',
    PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE:
        'Coś poszło nie tak. Spróbuj ponownie.',
    PASSIVE_LIVENESS_ERROR_NULLPTR_TITLE: 'Ojej... Coś poszło nie tak.',
    PASSIVE_LIVENESS_ERROR_NULLPTR: 'Coś poszło nie tak. Spróbuj ponownie.',
    PASSIVE_LIVENESS_ERROR_LICENSE_ERROR_TITLE: 'Ojej... Coś poszło nie tak.',
    PASSIVE_LIVENESS_ERROR_LICENSE_ERROR:
        'Coś poszło nie tak. Spróbuj ponownie.',
    PASSIVE_LIVENESS_ERROR_INVALID_META_TITLE: 'Ojej... Coś poszło nie tak.',
    PASSIVE_LIVENESS_ERROR_INVALID_META:
        'Coś poszło nie tak. Spróbuj ponownie.',
    INITIALIZING_TITLE: 'Inicjowanie',
    INITIALIZING_DESCRIPTION:
        'Sprawdzanie możliwości sprzętowych, proszę czekać...',
    JOURNEY_STATE_STARTED: 'Rozpoczęty.',
    JOURNEY_STATE_INPROGRESS: 'W trakcie.',
    JOURNEY_STATE_ENDED: 'Zakończony',
    INFO_JOURNEY_STATE: 'Stan',
    INFO_JOURNEY_ACTION: 'Działanie',
    INFO_JOURNEY_ACTION_ATTEMPT: 'Próba działania',
    INFO_JOURNEY_ID: 'ID ścieżki',
    INFO_JOURNEY_RESULT: 'Wynik',
    RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE: 'Komunikat o wyniku',
    RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE_VALUE:
        'Podany przez Ciebie identyfikator jest nieaktualny – spróbuj czegoś innego',
    INFO_JOURNEY_REFERENCE: 'Odniesienie',
    FLOW_STATE_NONE: 'Brak',
    'FLOW_STATE_IDENTITY:FRONT': 'Przednia strona',
    'FLOW_STATE_IDENTITY:BACK': 'Tylna strona',
    FLOW_STATE_ADDRESS: 'Adres',
    FLOW_STATE_SELFIE: 'Selfie',
    FLOW_STATE_LIVENESS: 'Żywość',
    FLOW_STATE_COVID: 'Covid',
    PROVIDER_TITLE_CAMERA: 'Aparat fotograficzny',
    PROVIDER_TITLE_CROPPER: 'Przycinanie',
    PROVIDER_TITLE_FILESYSTEM_ID:
        'Prześlij zdjęcie swojego dokumentu tożsamości',
    PROVIDER_TITLE_FILESYSTEM_FACEMATCH: 'Prześlij swoje zdjęcie',
    PROVIDER_TITLE_FILESYSTEM_ADDRESS: 'Prześlij zdjęcie swojego dowodu adresu',
    PROVIDER_TITLE_FILESYSTEM_COVID: 'Prześlij zdjęcie swojego dokumentu Covid',
    PROVIDER_TITLE_GATEWAY: 'Brama',
    PROVIDER_TITLE_LIVENESS: 'Aktywność',
    PROVIDER_TITLE_LOGIN: 'Logowanie',
    PROVIDER_TITLE_RESULTS: 'Wyniki',
    PROVIDER_TITLE_SCANNER: 'Zeskanuj swój dokument tożsamości',
    PROVIDER_TITLE_VIEW_ID: 'Sprawdź podgląd swojego dokumentu tożsamości',
    PROVIDER_TITLE_VIEW_FACEMATCH: 'Sprawdź podgląd swojego selfie',
    PROVIDER_TITLE_VIEW_ADDRESS: 'Sprawdź podgląd swojego dowodu adresu',
    ROVIDER_TITLE_VIEW_COVID: 'Sprawdź podgląd swojego Covid',
    PROVIDER_SUBTITLE_FILESYSTEM_ID:
        'Prześlij zdjęcie swojego dokumentu tożsamości, które jest wyraźne, ostre, niezasłonięte i skierowane bezpośrednio na osobę.',
    PROVIDER_SUBTITLE_FILESYSTEM_FACEMATCH:
        'Proszę przesłać zdjęcie przedstawiające Ciebie, wyraźne, ostre, niezasłonięte i skierowane bezpośrednio na Ciebie.',
    PROVIDER_SUBTITLE_FILESYSTEM_ADDRESS:
        'Prześlij zdjęcie dokumentu, wyraźne, ostre, niezasłonięte i skierowane bezpośrednio do Ciebie.',
    PROVIDER_SUBTITLE_FILESYSTEM_COVID:
        'Sprawdź, czy podgląd dokumentu jest wyraźny, ostry, niezasłonięty i skierowany bezpośrednio na osobę.',
    PROVIDER_SUBTITLE_SCANNER_ID:
        'Sprawdź, czy podgląd Twojego selfie jest wyraźny, ostry, niezasłonięty i skierowany bezpośrednio na osobę.',
    PROVIDER_SUBTITLE_VIEW_ID:
        'Sprawdź, czy podgląd Twojego dokumentu jest wyraźny, ostry, niezasłonięty i skierowany bezpośrednio na osobę.',
    PROVIDER_SUBTITLE_VIEW_FACEMATCH:
        'Sprawdź, czy podgląd Twojego dokumentu jest wyraźny, ostry, niezasłonięty i skierowany bezpośrednio na osobę.',
    PROVIDER_SUBTITLE_VIEW_ADDRESS:
        'Sprawdź, czy podgląd Twojego dokumentu jest wyraźny, ostry, niezasłonięty i skierowany bezpośrednio na osobę.',
    PROVIDER_SUBTITLE_VIEW_COVID:
        'Sprawdź, czy podgląd Twojego dokumentu jest wyraźny, ostry, niezasłonięty i skierowany bezpośrednio na osobę.',
    PROVIDER_TITLE_SMART_CAPTURE: 'Inteligentne Przechwytywanie',
    PROVIDER_TITLE_JOURNEY_SELECT: 'Wybierz ścieżkę',
    PROVIDER_TITLE_TERMS_AND_CONDITIONS: 'Regulamin',
    PROVIDER_TITLE_USER_INPUT: 'Wypełnij poniższy formularz',
    FILESYSTEM_SUPPORTED_TYPES_FIRST: 'Akceptowane formaty:',
    FILESYSTEM_SUPPORTED_TYPES_LIST: 'JPG, PNG',
    FILESYSTEM_SUPPORTED_TYPES_START_SELFIE: 'Akceptowane formaty: JPG, PNG',
    FILESYSTEM_MAX_FILE_SIZE:
        'Rozmiar pliku: akceptujemy wszystkie pliki o rozmiarze mniejszym niż',
    FILESYSTEM_MAX_FILE_SIZE_NUMBER: '7,5 MB',
    FILESYSTEM_CHECK_FILE_TOO_BIG:
        'Twój plik jest za duży. Prześlij plik o rozmiarze mniejszym niż 7,5 MB.',
    FILESYSTEM_CHECK_FILE_INCORRECT_FORMAT:
        'Twój plik ma nieprawidłowy format. Prześlij jeden z akceptowanych formatów.',
    FILESYSTEM_IDENTITY_DOCUMENT: 'Dokument tożsamości',
    FILESYSTEM_FACEMATCH: 'Dopasowanie twarzy',
    FILESYSTEM_ADDRESS: 'Dowód adresu',
    FILESYSTEM_COVID: 'Covid',
    FILESYSTEM_DRAG_DROP: 'Przeciągnij i upuść',
    FILESYSTEM_OR: 'lub',
    FILESYSTEM_CHOOSE: 'Wybierz plik',
    FILESYSTEM_UPLOADING: 'Przesyłanie...',
    TRIPLESCAN_GUIDANCE_TRYAGAIN: 'Spróbuj ponownie',
    FAILURE_REASON_REFER: 'Twój dokument tożsamości nie przeszedł weryfikacji.',
    FAILURE_REASON_EXPIRED: 'Twój dokument tożsamości stracił ważność.',
    FAILURE_REASON_NOT_ACCEPTED:
        'Twój dokument tożsamości nie jest akceptowanym typem dokumentu.',
    FAILURE_REASON_NOT_SUPPORTED:
        'Twój dokument tożsamości nie mógł zostać sklasyfikowany lub nie jest obsługiwany.',
    PLEASE_TRY_AGAIN_REFER: 'Spróbuj ponownie.',
    PLEASE_TRY_AGAIN_EXPIRED: 'Spróbuj ponownie z prawidłowym dokumentem.',
    PLEASE_TRY_AGAIN_NOT_ACCEPTED: 'Spróbuj ponownie z innym dokumentem.',
    PLEASE_TRY_AGAIN_NOT_SUPPORTED: 'Spróbuj ponownie.',
    BLUR_CHECK_REASON: 'Rozmycie — dokument jest niewyraźny;',
    GLARE_CHECK_REASON:
        'Odblask - dokument jest nieczytelny z powodu jasnego źródła światła;',
    RESOLUTION_CHECK_REASON:
        'Niska rozdzielczość - dokument nie wypełnia prawidłowo ramki;',
    EDGES_CHECK_REASON:
        'Brakujące krawędzie - dokument nie jest prawidłowo umieszczony w ramce;',
    VALIDATION_FAILED: 'Niepowodzenie weryfikacji',
    VALIDATION_FAILED_REASON_DOC_UNKNOWN: '- dokument nieznany.',
    VALIDATION_FAILED_REASON_DOC_NOT_ACCEPTED: '- dokument niezaakceptowany.',
    VALIDATION_FAILED_REASON_DOC_EXPIRED: '- dokument wygasł.',
    PREVIEW_INFO_TITLE_ID: 'Przykłady dobrych i złych zdjęć',
    PREVIEW_INFO_GOOD: 'Dobre',
    PREVIEW_INFO_BAD: 'Złe',
    PREVIEW_INFO_GOOD_EXAMPLE_ID:
        'Zdjęcie jest wyraźne, ostre i skierowane bezpośrednio na twarz.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ID:
        'Zdjęcie musi pokazywać wszystkie cztery rogi.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_ID: 'Dokument nie może być zasłonięty.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_ID: 'Zdjęcie nie może być rozmazane.',
    PREVIEW_INFO_TITLE_FACEMATCH: 'Wskazówki dotyczące dobrej jakości selfie',
    PREVIEW_INFO_GOOD_EXAMPLE_FACEMATCH:
        'Selfie musi być wyraźne, ostre i bezpośrednio na twarzy.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_FACEMATCH:
        'Selfie musi pokazywać całą twarz.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_FACEMATCH: 'Twarz nie może być zasłonięta.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_FACEMATCH: 'Selfie nie może być rozmazane.',
    PREVIEW_INFO_TITLE_ADDRESS: 'Wskazówki dotyczące dobrej jakości zdjęcia',
    PREVIEW_INFO_GOOD_EXAMPLE_ADDRESS:
        'Zdjęcie musi być wyraźne, ostre i bezpośrednio na twarzy.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ADDRESS:
        'Zdjęcie musi pokazywać wszystkie cztery rogi.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_ADDRESS: 'Dokument nie może być zasłonięty.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_ADDRESS: 'Zdjęcie nie może być rozmazane.',
    PREVIEW_INFO_TITLE_COVID: 'Wskazówki dotyczące dobrej jakości zdjęcia',
    PREVIEW_INFO_GOOD_EXAMPLE_COVID:
        'Zdjęcie musi być wyraźne, ostre i skierowane bezpośrednio na twarz.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_COVID:
        'Zdjęcie musi pokazywać wszystkie cztery rogi.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_COVID: 'Dokument nie może być zasłonięty.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_COVID: 'Zdjęcie nie może być rozmazane.',
    ATTEMPTS_REMAINING: 'Ilość pozostałych prób:',
    CAMERA_CAPTURE: 'Włącz aparat',
    CAMERA_CAPTURE_START_BUTTON: 'Rozpocznij automatyczne przechwytywanie',
    CAMERA_CAPTURE_CAPTION:
        'Kliknij Rozpocznij automatyczne przechwytywanie, aby rozpocząć',
    CAMERA_PREVIEW_START:
        'Włącz aparat, aby rozpocząć automatyczne przechwytywanie',
    CAMERA_CONDITION_BLUR: 'Wykryto rozmycie',
    CAMERA_CONDITION_CAPTURING: 'Przechwytywanie',
    CAMERA_CONDITION_UPLOADING: 'Przesyłanie... Proszę czekać',
    CAMERA_CONDITION_ALIGNMENT: 'Dokument nie znajduje się w ramce',
    CAMERA_CONDITION_GLARE: 'Wykryto odblask',
    VERIFYING_TITLE: 'Weryfikowanie...',
    PREPARING_PREVIEW_TITLE: 'Przygotowywanie podglądu...',
    CAMERA_CONDITION_LOW_RESOLUTION: 'Dokument jest za daleko',
    CAMERA_LOADING: 'Otwieranie aparatu...',
    CAMERA_SMARTCAPTURE_ON: 'AUTOMATYCZNE PRZECHWYTYWANIE — WŁ.',
    CAMERA_SMARTCAPTURE_OFF: 'AUTOMATYCZNE PRZECHWYTYWANIE — WYŁ.',
    CAMERA_CAPTURE_FRONT:
        'Umieść stronę ze zdjęciem dokumentu tożsamości w ramce poniżej.',
    CAMERA_MANUAL_CAPTURE_FRONT:
        'Umieść dokument tożsamości w ramce i kliknij przycisk poniżej',
    CAMERA_CAPTURE_BACK: 'Umieść TYŁ dokumentu tożsamości w ramce',
    CAMERA_CAPTURE_SELFIE_CAPTION:
        'Umieść twarz w owalu, spójrz bezpośrednio w aparat i kliknij przycisk poniżej, aby zrobić sobie selfie.',
    AMERA_CAPTURE_ADDRESS_CAPTION:
        'Umieść dowód adresu w ramce i kliknij przycisk poniżej, aby zrobić zdjęcie.',
    CAMERA_CAPTURE_COVID_CAPTION:
        'Umieść dokument Covid w ramce i kliknij przycisk poniżej, aby zrobić zdjęcie.',
    CAMERA_PREVENT_GLARE_HINT:
        'Odsuń dokument od bezpośrednich źródeł światła.',
    CAMERA_PREVENT_BLUR_HINT: 'Trzymaj dokument lub urządzenie nieruchomo.',
    CAMERA_PREVENT_LOW_RES_HINT: 'Dopasuj dokument całkowicie do ramki.',
    CROPPER_RETRY: 'Spróbuj ponownie',
    CROPPER_UPLOAD: 'Prześlij',
    CROPPER_UPLOADING: 'Przesyłanie...',
    FILESYSTEM_SELECT: 'Wybierz',
    FILESYSTEM_DROP_IMAGE: 'lub upuść obraz',
    GATEWAY_CAMERA: 'Aparat włączony',
    GATEWAY_CANCEL: 'Anuluj ścieżkę',
    LIVENESS_START: 'Rozpocznij aktywność',
    PASSIVE_LIVENESS_START: 'Zrób zdjęcie',
    LOGIN_USERNAME: 'Nazwa użytkownika',
    LOGIN_PASSWORD: 'Hasło',
    LOGIN_SUBMIT: 'Prześlij',
    RESULTS_DOCUMENTS: 'Dokumenty',
    RESULTS_DOCUMENTS_NONE: 'Nie znaleziono',
    RESULTS_DOCUMENT_TYPE: 'Typ dokumentu',
    RESULTS_DOCUMENT_RESULT: 'Wynik dokumentu',
    RESULTS_EXTRACTED_FIELDS_NONE: 'Szczegóły wyników',
    RESULTS_DETAILS_NONE: 'Nie znaleziono',
    RESULTS_NEW_JOURNEY: 'Rozpocznij nową ścieżkę',
    RESULTS_NO_INFORMATION: 'Brak informacji na temat tej ścieżki',
    RESULTS_LOGOUT: 'Wyloguj',
    RESULTS_HIGH_LEVEL_Aborted: 'Przerwany',
    RESULTS_HIGH_LEVEL_TCCDISAGREE: "Przerwane T&C's",
    RESULTS_HIGH_LEVEL_Expired: 'Wygasło',
    RESULTS_HIGH_LEVEL_NotAccepted: 'Nieakceptowany',
    RESULTS_HIGH_LEVEL_NotSupported: 'Nieobsługiwane',
    RESULTS_HIGH_LEVEL_Notsupported: 'Nieobsługiwane',
    RESULTS_HIGH_LEVEL_Passed: 'Zatwierdzono',
    RESULTS_HIGH_LEVEL_Refer: 'Odniesienie',
    RESULTS_HIGH_LEVEL_Undefined: 'Nieokreślony',
    RESULTS_HIGH_LEVEL_DETAIL_ACCUMULATIVELIVENESSRESULT:
        'Łączny wynik aktywności',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTFRONTSIDETYPECHECK:
        'Sprawdzenie typu przedniej strony dokumentu',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBACKSIDECHECK:
        'Sprawdzanie tyłu dokumentu',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBLOCKINGPOLICY:
        'Polityka blokowania dokumentów',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTEXPIRY: 'Data ważności dokumentu',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTSUPPORT: 'Wsparcie dokumentu',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTVALIDATION: 'Walidacja dokumentu',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTPROOFPOLICY:
        'Polityka udowadniania dokumentów',
    RESULTS_HIGH_LEVEL_DETAIL_FACEMATCHVALIDATION: 'Walidacja Facematch',
    RESULTS_HIGH_LEVEL_DETAIL_UNDERAGERULE: 'Reguła dotycząca nieletnich',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_SUCCESS_NEEDED: 'Sukces wymagany',
    RESULTS_HIGH_LEVEL_DETAIL_COVID_PASS_CROSSCHECK:
        'Sprawdzanie zgodności paszportu Covid',
    RESULTS_HIGH_LEVEL_DETAIL_DATA_CHECK: 'Sprawdzanie danych',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_FAILED: 'Niepowodzenie',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_NOTNEEDED: 'Niepotrzebne',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_PASSED: 'Zatwierdzono',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_SKIPPED: 'Pominięte',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_UNDETERMINED: 'Nieokreślony',
    ADDITIONAL_CHECKS_DETAILS: 'Dodatkowe kontrole',
    ADDITIONAL_CHECKS_DETAILS_NONE: 'Nie znaleziono',
    ADDITIONAL_CHECKS_DETAIL_DATACHECKS: 'Kontrole danych',
    ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK: 'Sprawdzenia wsteczne',
    ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK_NA: 'NIE DOTYCZY',
    GBG_SCORES: 'Wyniki GBG',
    GBG_TRUST_SCORE: 'Wynik zaufania GBG',
    GBG_SCORE: 'Wynik GBG',
    PREVIEW_TITLE: 'Czy zdjęcie twojego dokumentu jest wyraźne?',
    VIEW_RETRY: 'ZRÓB ZDJĘCIE PONOWNIE',
    VIEW_RETRY_DESKTOP: 'Usuń',
    VIEW_CROP: 'Kadr',
    VIEW_CROPPING: 'Kadrowanie...',
    VIEW_UPLOAD: 'KONTYNUUJ',
    VIEW_UPLOAD_PREVIEW: 'TAK, KONTYNUUJ',
    VIEW_UPLOADING: 'Wczytywanie...',
    SMART_CAPTURE_INITIALIZING: 'Rozpocznij',
    SMART_CAPTURE_START: 'Inicjowanie Smart Capture, proszę czekać...',
    SCANNER_DESC_AVAILABLE:
        'Skaner jest dostępny. Umieść swój dokument w skanerze.',
    SCANNER_DESC_PROCESSING: 'Obraz jest przetwarzany przez serwer.',
    SCANNER_DESC_SCANNING: 'Obraz jest skanowany przez urządzenie.',
    SCANNER_DESC_DISCONNECTED: 'Skaner nie jest połączony z siecią.',
    SCANNER_DESC_NOT_CONNECTED: 'Skaner nie jest podłączony.',
    SCANNER_DESC_OFFLINE: 'Skaner jest offline.',
    SCANNER_DESC_BUSY:
        'Skaner jest używany przez innego użytkownika w twojej lokalnej sieci.',
    SCANNER_DESC_WAITING: 'Oczekiwanie na nawiązanie połączenia.',
    SCANNER_DESC_LOADING: 'Proszę czekać...',
    SCANNER_TITLE_SCANNING: 'Skanowanie...',
    SCANNER_TITLE_DISCONNECTED: 'ODŁĄCZONY',
    SCANNER_TITLE_NOT_CONNECTED: 'NIEPOŁĄCZONY',
    SCANNER_TITLE_OFFLINE: 'Skaner offline',
    SCANNER_TITLE_BUSY: 'Skaner zajęty',
    SCANNER_TITLE_WAITING: 'OCZEKIWANIE',
    SCANNER_ACTION_REGISTER: 'Rejestr',
    SCANNER_ACTION_RELEASE: 'Wydanie',
    CANCEL_JOURNEY: 'Anuluj',
    MANUAL_PHOTO_UPLOAD_TOGGLE_FALSE: 'Zamiast tego prześlij zdjęcie',
    MANUAL_PHOTO_UPLOAD_TOGGLE_TRUE: 'Zamiast tego zrób zdjęcie',
    JOURNEY_SELECT_CONTINUE: 'Kontynuuj',
    HELP_MODAL_AUTOCAPTURE_TITLE: 'Jak zrobić zdjęcie dokumentu tożsamości',
    HELP_MODAL_AUTOCAPTURE_SUBTITLE:
        'Gdy funkcja automatycznego przechwytywania jest włączona, ekran przechwytywania automatycznie zrobi zdjęcie dokumentu, gdy uzna, że jest ono wystarczająco dobrej jakości.',
    HELP_MODAL_AUTOCAPTURE_TIPS:
        'Wskazówki dotyczące robienia zdjęć dobrej jakości',
    HELP_MODAL_AUTOCAPTURE_GLARE_TITLE: 'Zapobieganie oślepianiu',
    HELP_MODAL_AUTOCAPTURE_GLARE_SUBTITLE:
        'Odsuń dokument od bezpośrednich źródeł światła.',
    HELP_MODAL_AUTOCAPTURE_FAR_TITLE: 'Dokument za daleko',
    AUTOCAPTURE_FAR_SUBTITLE: 'Dopasuj dokument w całości do ramki.',
    AUTOCAPTURE_BLUR_TITLE: 'Zapobieganie rozmyciu',
    HELP_MODAL_AUTOCAPTURE_BLUR_SUBTITLE:
        'Trzymaj dokument lub urządzenie stabilnie.',
    HELP_MODAL_AUTOCAPTURE_MANUAL_CAPTURE:
        'Nadal masz trudności? Zrób zdjęcie za pomocą funkcji Manual Capture',
    HELP_MODAL_AUTOCAPTURE_TURN_MANUAL_CAPTURE: 'Przechwytywanie ręczne',
    HELP_MODAL_SELFIE_TITLE: 'Jak zrobić selfie',
    HELP_MODAL_SELFIE_SUBTITLE:
        'Spójrz bezpośrednio w kamerę i kliknij przycisk przechwytywania ręcznego.',
    HELP_MODAL_POA_TITLE: 'Jak zrobić zdjęcie dowodu adresu',
    HELP_MODAL_POA_SUBTITLE:
        'Umieść dokument w ramce i kliknij przycisk przechwytywania, aby zrobić zdjęcie dokumentu.',
    HELP_MODAL_POA_TIPS: 'Wskazówki dotyczące robienia zdjęć dobrej jakości',
    HELP_MODAL_POA_GLARE_TITLE: 'Zapobieganie oślepianiu',
    HELP_MODAL_POA_GLARE_SUBTITLE:
        'Odsuń dokument od bezpośrednich źródeł światła.',
    HELP_MODAL_POA_FAR_TITLE: 'Dokument za daleko',
    HELP_MODAL_POA_FAR_SUBTITLE: 'Dopasuj dokument w całości do ramki.',
    HELP_MODAL_POA_BLUR_TITLE: 'Zapobieganie rozmyciu',
    HELP_MODAL_POA_BLUR_SUBTITLE: 'Trzymaj dokument lub urządzenie stabilnie.',
    HELP_MODAL_POA_MANUAL_CAPTURE:
        'Nadal masz trudności? Włącz przechwytywanie ręczne',
    HELP_MODAL_POA_TURN_MANUAL_CAPTURE: 'Przechwytywanie ręczne',
    HELP_MODAL_COVID_TITLE: 'Jak zrobić zdjęcie dokumentu Covid',
    HELP_MODAL_COVID_SUBTITLE:
        'Umieść dokument w ramce i kliknij przycisk przechwytywania, aby zrobić zdjęcie dokumentu.',
    HELP_MODAL_COVID_TIPS: 'Wskazówki dotyczące robienia zdjęć dobrej jakości',
    HELP_MODAL_COVID_GLARE_TITLE: 'Zapobieganie oślepianiu',
    HELP_MODAL_COVID_GLARE_SUBTITLE:
        'Odsuń dokument od bezpośrednich źródeł światła.',
    HELP_MODAL_COVID_FAR_TITLE: 'Dokument za daleko',
    HELP_MODAL_COVID_FAR_SUBTITLE: 'Dopasuj dokument w całości do ramki.',
    HELP_MODAL_COVID_BLUR_TITLE: 'Zapobieganie rozmyciu',
    HELP_MODAL_COVID_BLUR_SUBTITLE:
        'Trzymaj dokument lub urządzenie stabilnie.',
    HELP_MODAL_COVID_MANUAL_CAPTURE:
        'Nadal masz trudności? Włącz przechwytywanie ręczne',
    HELP_MODAL_COVID_TURN_MANUAL_CAPTURE: 'Przechwytywanie ręczne',
    HELP_MODAL_NEED_HELP: 'Pomoc i opcje',
    EXCEPTION: 'Wystąpił nieoczekiwany wyjątek',
    EXCEPTION_AUTHORIZATION: 'Nieautoryzowany',
    EXCEPTION_AUTHORIZATION_ACCOUNT_NOT_AUTHORIZED:
        'Twoje konto nie jest uprawnione do dostępu do tego zasobu',
    EXCEPTION_AUTHORIZATION_AUTH_DETAILS_INVALID:
        'Kombinacja nazwy użytkownika i hasła jest nieprawidłowa',
    EXCEPTION_AUTHORIZATION_AUTH_NOT_ENABLED:
        'Musisz włączyć autoryzację, aby korzystać z tej funkcji',
    EXCEPTION_AUTHORIZATION_PROCESS_NOT_AUTHORIZED:
        'Nie masz uprawnień do tego procesu',
    EXCEPTION_BAD_REQUEST: 'Błędne żądanie z kodem statusu 400',
    EXCEPTION_BAD_REQUEST_INVALID_IMAGE: 'Nieprawidłowy obraz',
    EXCEPTION_BAD_REQUEST_WAITING_FOR_RESPONSE: 'Podróż oczekuje na odpowiedź',
    EXCEPTION_FLOW_STATE_JOURNEY_ENDED:
        'Nie można wysyłać żądań. Podróż została zakończona',
    EXCEPTION_FLOW_STATE_MISSING: 'Nie znaleziono stanu przepływu',
    EXCEPTION_INVALID_PARAMETER_CALLBACK_MUST_BE_FUNCTION:
        'Wywołanie zwrotne musi być poprawną funkcją',
    EXCEPTION_INVALID_PARAMETER_NAME_MUST_BE_STRING:
        'Nazwa wydarzenia musi być wartością ciągu znaków.',
    EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_NUMBER:
        'Priorytet musi być liczbą.',
    EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_POSITIVE_NUMBER:
        'Priorytet musi być liczbą dodatnią.',
    EXCEPTION_INVALID_PARAMETER_SHOULD_BE_ELEMENT_OR_SELECTOR:
        'Kontener powinien być albo elementem, albo selektorem.',
    EXCEPTION_INVALID_PARAMETER_VALUE_NOT_VALID: 'Wartość jest nieprawidłowa.',
    EXCEPTION_INVALID_PARAMETER_VALUE_DAMAGED: 'Wartość została uszkodzona.',
    EXCEPTION_MISSING_PARAMETER_BACKEND_URL_MISSING:
        'Konfiguracja powinna zawierać parametr backendUrl.',
    EXCEPTION_MISSING_PARAMETER_COORDINATES_MISSING:
        'Dostarczone parametry muszą zawierać współrzędne.',
    EXCEPTION_MISSING_PARAMETER_IMAGES_MISSING:
        'Dostarczone parametry muszą zawierać obrazy.',
    EXCEPTION_MISSING_PARAMETER_PASSWORD_MISSING:
        'Dostarczone parametry powinny zawierać hasło.',
    EXCEPTION_MISSING_PARAMETER_USERNAME_MISSING:
        'Dostarczone parametry powinny zawierać nazwę użytkownika.',
    EXCEPTION_MISSING_REQUIRED_FIELD_MISSING:
        'Wypełnij wszystkie wymagane pola',
    EXCEPTION_POSTCODE_FORMAT_ERROR:
        'Format kodu pocztowego jest nieprawidłowy minDługość:5 / maxDługość:8',
    EXCEPTION_HOUSENUMBER_FORMAT_ERROR:
        'Format nazwy/numeru domu jest nieprawidłowy minDługość:1 / maxDługość:20',
    EXCEPTION_STREETNAME_FORMAT_ERROR:
        'Nazwa ulicy jest nieprawidłowa minDługość:1 / maxDługość:30',
    EXCEPTION_TOWN_FORMAT_ERROR:
        'Format miasta jest nieprawidłowy minLength:1 / maxLength:20',
    EXCEPTION_JOURNEY_DEFINITIONS_MISSING:
        'Dla tego kanału nie są dostępne definicje podróży',
    EXCEPTION_NETWORK:
        'Wystąpił wyjątek sieciowy, sprawdź połączenie i spróbuj ponownie.',
    EXCEPTION_PLATFORM_BROWSER_ONLY:
        'Ta funkcja może być używana tylko w przeglądarce',
    EXCEPTION_PLATFORM_UNSUPPORTED: 'Środowisko nie obsługuje tej funkcji',
    EXCEPTION_PLATFORM_CAMERA_PERMISSION_DENIED:
        'Nie przyznano uprawnień do kamery, sprawdź ustawienia przeglądarki',
    EXCEPTION_PLATFORM_CAMERA_PERMISSION_UNAVAILABLE:
        'Uprawnienia do kamery są niedostępne',
    EXCEPTION_PLATFORM_CAMERA_NOT_READABLE:
        'Nie można uzyskać dostępu do kamery. Zamknij inne aplikacje i spróbuj ponownie',
    EXCEPTION_PLATFORM_CAMERA_NONE_SUITABLE:
        'Nie znaleziono odpowiednich kamer na urządzeniu',
    EXCEPTION_SERVER: 'Żądanie nie powiodło się z kodem statusu 500',
    EXCEPTION_SERVER_UNREACHABLE:
        'Żądanie nie powiodło się, serwer nieosiągalny',
    EXCEPTION_SERVER_DATA_NOT_PERSISTED:
        'Podczas procesu wystąpił błąd. Dane mogą nie zostać zapisane',
    EXCEPTION_SERVER_RESULT_NOT_PASSING: 'Bieżący wynik nie przechodzi',
    EXCEPTION_TEMPLATE_CANVAS_CONTEXT_UNAVAILABLE:
        'Kontekst Canvas nie jest dostępny',
    EXCEPTION_TEMPLATE_CONTAINER_MISSING: 'Kontener nie jest obecny',
    EXCEPTION_TEMPLATE_ELEMENTS_MISSING: 'Brak wymaganych elementów',
    EXCEPTION_TEMPLATE_MISSING: 'Nie znaleziono szablonu',
    EXCEPTION_TEMPLATE_SOURCE_ELEMENT_MISSING:
        'Nie można znaleźć elementu źródłowego',
    EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_CANNOT_RETRIEVE:
        'Nie można uzyskać dostawców danych wejściowych',
    EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NONE_SPECIFIED:
        'Nie określono dostawców danych wejściowych',
    EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NOT_AVAILABLE:
        'Dostawca danych wejściowych nie jest dostępny',
    'SUPPORTED_DOCUMENT_Account Statement': 'Wyciąg z konta',
    'SUPPORTED_DOCUMENT_Agreement (Tenancy)': 'Umowa (Najmu)',
    'SUPPORTED_DOCUMENT_Bank Document': 'Dokument bankowy',
    'SUPPORTED_DOCUMENT_Bank Letter': 'List bankowy',
    'SUPPORTED_DOCUMENT_Bank Statement': 'Wyciąg bankowy',
    'SUPPORTED_DOCUMENT_Benefit Letter': 'List korzyści',
    'SUPPORTED_DOCUMENT_Certificate (Birth, Marriage, Civil partnership)':
        'Świadectwo (urodzenia, małżeństwa, związku cywilnego)',
    'SUPPORTED_DOCUMENT_Council Document': 'Dokument Rady',
    'SUPPORTED_DOCUMENT_Council Letter': 'List Rady',
    'SUPPORTED_DOCUMENT_Council Tax': 'Podatek od nieruchomości',
    'SUPPORTED_DOCUMENT_Driving License': 'Prawo jazdy',
    'SUPPORTED_DOCUMENT_Driving Licence': 'Prawo jazdy',
    'SUPPORTED_DOCUMENT_DWP Document': 'Dokument DWP',
    'SUPPORTED_DOCUMENT_HMRC Document': 'Dokument HMRC',
    'SUPPORTED_DOCUMENT_Information Sheet': 'Arkusz informacyjny',
    'SUPPORTED_DOCUMENT_Insurance Document': 'Dokument ubezpieczeniowy',
    'SUPPORTED_DOCUMENT_Insurance Letter': 'List ubezpieczenia',
    SUPPORTED_DOCUMENT_Invoice: 'Faktura',
    'SUPPORTED_DOCUMENT_NIC Letter': 'List NIC',
    'SUPPORTED_DOCUMENT_NINO Letter': 'List NINO',
    'SUPPORTED_DOCUMENT_Official Document': 'Oficjalny dokument',
    'SUPPORTED_DOCUMENT_Official Letter': 'Oficjalny List',
    'SUPPORTED_DOCUMENT_Repayment Letter (related to Tax or Social support)':
        'List spłaty (dotyczący podatku lub wsparcia społecznego)',
    'SUPPORTED_DOCUMENT_Tax Letter': 'List podatkowy',
    'SUPPORTED_DOCUMENT_Tax Statement': 'Oświadczenie podatkowe',
    'SUPPORTED_DOCUMENT_Tel Bill': 'Rachunek telefoniczny',
    'SUPPORTED_DOCUMENT_Tel Letter': 'List Tel',
    'SUPPORTED_DOCUMENT_Telecommunication Document':
        'Dokument telekomunikacyjny',
    'SUPPORTED_DOCUMENT_TV Licence': 'Abonament telewizyjny',
    'SUPPORTED_DOCUMENT_University Letter': 'List Uniwersytecki',
    'SUPPORTED_DOCUMENT_Utility Bill': 'Rachunek za media',
    'SUPPORTED_DOCUMENT_Utility Document': 'Dokument użytkowy',
    'SUPPORTED_DOCUMENT_Utility Letter': 'List Usług',
    'SUPPORTED_DOCUMENT_Water Bil': 'Woda Bil',
    'SUPPORTED_DOCUMENT_Water Document': 'Dokument wody',
    'SUPPORTED_DOCUMENT_Agents License': 'Licencja agenta',
    'SUPPORTED_DOCUMENT_Electoral Card': 'Karta wyborcza',
    'SUPPORTED_DOCUMENT_Foreigner Identification Card':
        'Karta identyfikacyjna dla obcokrajowców',
    'SUPPORTED_DOCUMENT_Health Card': 'Karta zdrowia',
    'SUPPORTED_DOCUMENT_Job License': 'Licencja zawodowa',
    'SUPPORTED_DOCUMENT_Membership Identification Card':
        'Członkowska karta identyfikacyjna',
    'SUPPORTED_DOCUMENT_Military Identification Card':
        'Wojskowa karta identyfikacyjna',
    'SUPPORTED_DOCUMENT_National Identification Card':
        'Narodowej karta tożsamości',
    SUPPORTED_DOCUMENT_Passport: 'Paszport',
    'SUPPORTED_DOCUMENT_Travel Permit': 'Zezwolenie podróżne',
    SUPPORTED_DOCUMENT_Visa: 'Wiza',
    'SUPPORTED_DOCUMENT_Weapons Licence': 'Licencja na broń',
    'SUPPORTED_DOCUMENT_Selfie Photo': 'Zdjęcie selfie',
    SUPPORTED_DOCUMENT_Unknown: 'Nieznany',
    SUPPORTED_DOCUMENT_COVIDPAS: 'Paszport Covid',
    EXTRACTED_FIELDS_AddressFull: 'Adres pełny',
    EXTRACTED_FIELDS_AddressCity: 'Adres Miasto',
    EXTRACTED_FIELDS_AddressPostCode: 'Adres Kod pocztowy',
    EXTRACTED_FIELDS_LastNameFirstPart: 'Nazwisko Pierwsza Część',
    EXTRACTED_FIELDS_Sex: 'Płeć',
    EXTRACTED_FIELDS_BirthPlace: 'Miejsce urodzenia',
    EXTRACTED_FIELDS_IssueNumber: 'Numer wydania',
    EXTRACTED_FIELDS_DocumentNumberCheckDigit:
        'Cyfra kontrolna numeru dokumentu',
    EXTRACTED_FIELDS_BirthDate: 'Data urodzenia',
    EXTRACTED_FIELDS_DocumentNumber: 'Numer dokumentu',
    EXTRACTED_FIELDS_FirstName: 'Imię',
    EXTRACTED_FIELDS_ArbitraryDigit: 'Dowolna cyfra',
    EXTRACTED_FIELDS_FirstNameInitial: 'Pierwsza litera imienia',
    EXTRACTED_FIELDS_ExpiryDate: 'Data ważności',
    EXTRACTED_FIELDS_IssueDate: 'Data wydania',
    EXTRACTED_FIELDS_LastName: 'Nazwisko',
    EXTRACTED_FIELDS_LicenseCategory: 'Kategoria licencji',
    EXTRACTED_FIELDS_DocumentCategory: 'Kategoria dokumentu',
    EXTRACTED_FIELDS_DocumentType: 'Typ dokumentu',
    EXTRACTED_FIELDS_NationalityCode: 'Kod narodowości',
    EXTRACTED_FIELDS_MiddleName: 'Drugie imię',
    EXTRACTED_FIELDS_FirstIssuanceDate: 'Data pierwszego wydania',
    EXTRACTED_FIELDS_SecondLastName: 'Drugie Nazwisko',
    EXTRACTED_FIELDS_FullName: 'Pełne imię',
    EXTRACTED_FIELDS_PersonalNumber: 'Numer osobisty',
    EXTRACTED_FIELDS_NationalityName: 'Narodowość',
    EXTRACTED_FIELDS_BarcodeItems: 'Kod kreskowy',
    EXTRACTED_FIELDS_BirthPlaceCity: 'Miasto urodzenia',
    EXTRACTED_FIELDS_BirthPlaceState: 'Stan urodzenia',
    EXTRACTED_FIELDS_BirthPlaceCountry: 'Kraj urodzenia',
    EXTRACTED_FIELDS_MRZFull: 'Pełny MRZ',
    EXTRACTED_FIELDS_MRZLine1: 'Linia MRZ 1',
    EXTRACTED_FIELDS_MRZLine2: 'Linia MRZ 2',
    EXTRACTED_FIELDS_MRZLine3: 'Linia MRZ 3',
    EXTRACTED_FIELDS_ObservationPage: 'Strona obserwacji',
    EXTRACTED_FIELDS_IssuingAuthority: 'Organ wydający',
    EXTRACTED_FIELDS_IssuingLocation: 'Miejsce wydania',
    EXTRACTED_FIELDS_MaritalStatus: 'Stan cywilny',
    EXTRACTED_FIELDS_Occupation: 'Zajęcie',
    EXTRACTED_FIELDS_AlienNumber: 'Numer Obcy',
    EXTRACTED_FIELDS_Employer: 'Pracodawca',
    EXTRACTED_FIELDS_AddressLine1: 'Linia adresowa 1',
    EXTRACTED_FIELDS_AddressLine2: 'Linia adresu 2',
    EXTRACTED_FIELDS_AddressLine3: 'Linia adresowa 3',
    EXTRACTED_FIELDS_AddressLine4: 'Linia adresowa 4',
    EXTRACTED_FIELDS_AddressState: 'Stan',
    EXTRACTED_FIELDS_AddressDistrict: 'Dzielnica',
    EXTRACTED_FIELDS_AddressBuildingNumber: 'Numer budynku',
    EXTRACTED_FIELDS_AddressBuildingName: 'Nazwa budynku',
    EXTRACTED_FIELDS_AddressStreet: 'Ulica',
    EXTRACTED_FIELDS_AddressCountry: 'Kraj',
    EXTRACTED_FIELDS_RefAddressFull: 'Adres referencyjny',
    EXTRACTED_FIELDS_RefAddressLine1: 'Linia adresu referencyjnego 1',
    EXTRACTED_FIELDS_RefAddressLine2: 'Linia adresu referencyjnego 2',
    EXTRACTED_FIELDS_RefAddressLine3: 'Linia adresu referencyjnego 3',
    EXTRACTED_FIELDS_RefAddressLine4: 'Linia adresu referencyjnego 4',
    EXTRACTED_FIELDS_RefAddressCity: 'Adres referencyjny Miasto',
    EXTRACTED_FIELDS_RefAddressState: 'Stan adresu referencyjnego',
    EXTRACTED_FIELDS_RefAddressDistrict: 'Adres referencyjny Dzielnica',
    EXTRACTED_FIELDS_RefAddressBuildingNumber:
        'Numer referencyjny Adres Numer budynku',
    EXTRACTED_FIELDS_RefAddressBuildingName: 'Adres referencyjny Nazwa budynku',
    EXTRACTED_FIELDS_RefAddressSubBuildingName:
        'Nazwa budynku podadresowego referencyjnego',
    EXTRACTED_FIELDS_RefAddressStreet: 'Ulica Adresu Referencyjnego',
    EXTRACTED_FIELDS_RefAddressCountry: 'Adres referencyjny Kraj',
    EXTRACTED_FIELDS_RefAddressPostCode: 'Adres referencyjny Kod pocztowy',
    EXTRACTED_FIELDS_HealthNumber: 'Numer Zdrowia',
    EXTRACTED_FIELDS_Endorsements: 'Rekomendacje',
    EXTRACTED_FIELDS_Constraints: 'Ograniczenia',
    EXTRACTED_FIELDS_LicenseMarine: 'Licencja Morska',
    EXTRACTED_FIELDS_Height: 'Wzrost',
    EXTRACTED_FIELDS_Weight: 'Waga',
    EXTRACTED_FIELDS_HairColor: 'Kolor włosów',
    EXTRACTED_FIELDS_EyeColor: 'Kolor oczu',
    EXTRACTED_FIELDS_LensData: 'Wzrok',
    EXTRACTED_FIELDS_SocialSecurityNumber: 'Numer ubezpieczenia społecznego',
    EXTRACTED_FIELDS_NationalInsuranceNumber:
        'Krajowy numer ubezpieczenia społecznego',
    EXTRACTED_FIELDS_Race: 'Wyścig',
    EXTRACTED_FIELDS_MotherName: 'Imię matki',
    EXTRACTED_FIELDS_FatherName: 'Imię ojca',
    EXTRACTED_FIELDS_Parents: 'Rodzice',
    EXTRACTED_FIELDS_Remarks: 'Uwagi',
    EXTRACTED_FIELDS_DistinguishingMarks: 'Znaki szczególne',
    EXTRACTED_FIELDS_PeriodOfStay: 'Okres pobytu',
    EXTRACTED_FIELDS_TaxNumber: 'Numer podatkowy',
    EXTRACTED_FIELDS_Donor: 'Dawca',
    EXTRACTED_FIELDS_RFIDG1: 'Nieprzetworzone dane RFID Grupa 1',
    EXTRACTED_FIELDS_RFIDG2: 'Nieprzetworzone dane RFID Grupa 2',
    EXTRACTED_FIELDS_RFIDG3: 'Nieprzetworzone dane RFID Grupa 3',
    EXTRACTED_FIELDS_RFIDG15: 'Nieprzetworzone dane RFID Grupa 4',
    EXTRACTED_FIELDS_RFIDSOD: 'Nieprzetworzone dane RFID Grupa 5',
    EXTRACTED_FIELDS_PortraitPhoto: 'Wyodrębnione zdjęcie portretowe',
    EXTRACTED_FIELDS_Title: 'Tytuł',
    EXTRACTED_FIELDS_IssueDate2: 'Data drugiej emisji',
    EXTRACTED_FIELDS_ExpiryDate2: 'Druga data ważności',
    EXTRACTED_FIELDS_LicenseCategory2: 'Druga kategoria licencji',
    EXTRACTED_FIELDS_IssueDate3: 'Trzecia data wydania',
    EXTRACTED_FIELDS_ExpiryDate3: 'Trzecia data ważności',
    EXTRACTED_FIELDS_LicenseCategory3: 'Trzecia kategoria licencji',
    EXTRACTED_FIELDS_IssueDate4: 'Czwarta data wydania',
    EXTRACTED_FIELDS_ExpiryDate4: 'Czwarta data ważności',
    EXTRACTED_FIELDS_LicenseCategory4: 'Czwarta kategoria licencji',
    EXTRACTED_FIELDS_MRZCode1: 'Kod MRZ 1',
    EXTRACTED_FIELDS_MRZCode2: 'Kod MRZ 2',
    EXTRACTED_FIELDS_MRZStandardType: 'Standardowy typ MRZ',
    EXTRACTED_FIELDS_AddressStreetSuffix: 'Sufiks ulicy',
    EXTRACTED_FIELDS_AddressStreetType: 'Typ ulicy',
    EXTRACTED_FIELDS_AddressUnitNumber: 'Numer Jednostki Adresowej',
    EXTRACTED_FIELDS_LicenseNumber: 'Numer licencji',
    EXTRACTED_FIELDS_AddressStateCode: 'Kod stanu',
    EXTRACTED_FIELDS_AddressStreetTypeAbbreviation: 'Skrót ulicy',
    EXTRACTED_FIELDS_AddressUnitType: 'Typ Jednostki Adresowej',
    EXTRACTED_FIELDS_AddressDeliveryPointIdentifier:
        'Identyfikator punktu dostarczenia',
    EXTRACTED_FIELDS_AgeCategory: 'Kategoria wiekowa',
    EXTRACTED_FIELDS_ChildernCount: 'Liczba dzieci',
    EXTRACTED_FIELDS_EntryMode: 'Tryb wprowadzania',
    EXTRACTED_FIELDS_VAFNumber: 'Numer VAF',
    EXTRACTED_FIELDS_AddressLine5: 'Linia adresowa 5',
    EXTRACTED_FIELDS_RFIDPortraitPhoto: 'Zdjęcie portretowe RFID',
    EXTRACTED_FIELDS_RefAddressLine5: 'Adres referencyjny linia 5',
    EXTRACTED_FIELDS_RefAddressStateCode: 'Stan adresu referencyjnego',
    EXTRACTED_FIELDS_RefAddressStreetType: 'Typ ulicy adresu referencyjnego',
    EXTRACTED_FIELDS_RefAddressStreetTypeAbbreviation:
        'Skrót typu ulicy adresu referencyjnego',
    EXTRACTED_FIELDS_RefAddressStreetSuffix: 'Sufiks ulicy adresowej',
    EXTRACTED_FIELDS_RefAddressUnitNumber: 'Numer Jednostki Adresowej',
    EXTRACTED_FIELDS_RefAddressUnitType:
        'Typ Jednostki Adresowej Referencyjnej',
    EXTRACTED_FIELDS_RefAddressPostcodeType:
        'Adres odniesienia Kod pocztowy Typ',
    EXTRACTED_FIELDS_RefAddressDeliveryPointIdentifier:
        'Identyfikator punktu dostarczenia adresu referencyjnego',
    EXTRACTED_FIELDS_RefAddressPOBoxNumber:
        'Adres referencyjny numer skrytki pocztowej',
    EXTRACTED_FIELDS_RefAddressDependentLocality:
        'Lokalizacja zależna od adresu',
    EXTRACTED_FIELDS_RefAddressDoubleDependentLocality:
        'Adres referencyjny Podwójna lokalizacja zależna',
    EXTRACTED_FIELDS_RefAddressThoroughfare: 'Adres odniesienia Ulica',
    EXTRACTED_FIELDS_RefAddressThoroughfareDesc:
        'Opis adresu ulicy odniesienia',
    EXTRACTED_FIELDS_RefAddressDependentThoroughfare:
        'Zależna ulica od adresu referencyjnego',
    EXTRACTED_FIELDS_RefAddressDependentThoroughfareDesc:
        'Opis ulicy zależny od adresu referencyjnego',
    EXTRACTED_FIELDS_RefAddressSubBuildingNumber:
        'Numer odniesienia Adres Podnumer budynku',
    EXTRACTED_FIELDS_AddressSubBuildingNumber: 'Numer pod budynkiem',
    EXTRACTED_FIELDS_AddressSubBuildingName: 'Nazwa budynku',
    EXTRACTED_FIELDS_AddressPostCodeType: 'Typ kodu pocztowego',
    EXTRACTED_FIELDS_IssuingAuthorityType: 'Typ wydającego dokument',
    EXTRACTED_FIELDS_Signature: 'Podpis',
    EXTRACTED_FIELDS_Hologram: 'Hologram',
    EXTRACTED_FIELDS_CardNumber: 'Numer karty',
    EXTRACTED_FIELDS_MiddleNameInitial: 'Inicjał drugiego imienia',
    EXTRACTED_FIELDS_PermitNumber: 'Numer Pozwolenia',
    EXTRACTED_FIELDS_ReferenceNumber: 'Numer referencyjny',
    EXTRACTED_FIELDS_CustomerNumber: 'Numer klienta',
    EXTRACTED_FIELDS_BOSNumber: 'Numer BOS',
    EXTRACTED_FIELDS_StudentID: 'Numer identyfikacyjny studenta',
    EXTRACTED_FIELDS_MembershipNumber: 'Numer członkowski',
    EXTRACTED_FIELDS_LicenseType: 'Typ licencji',
    EXTRACTED_FIELDS_LicenseType2: 'Typ licencji 2',
    EXTRACTED_FIELDS_LicenseType3: 'Typ licencji 3',
    EXTRACTED_FIELDS_LicenseType4: 'Typ licencji 4',
    EXTRACTED_FIELDS_DocumentTypeCode: 'Kod typu dokumentu',
    EXTRACTED_FIELDS_MRZDocumentNumberCheckDigit: 'Cyfra kontrolna MRZ',
    EXTRACTED_FIELDS_MRZBirthDateCheckDigit:
        'Cyfra kontrolna daty urodzenia MRZ',
    EXTRACTED_FIELDS_MRZExpiryDateCheckDigit:
        'Cyfra kontrolna daty ważności MRZ',
    EXTRACTED_FIELDS_MRZPersonalNumberCheckDigit:
        'Cyfra kontrolna numeru osobistego MRZ',
    EXTRACTED_FIELDS_MRZCompositeCheckDigit: 'Cyfra kontrolna MRZ Composite',
    EXTRACTED_FIELDS_SecondaryPortraitPhoto: 'Zdjęcie portretowe drugorzędne',
    EXTRACTED_FIELDS_Fingerprint: 'Odcisk palca',
    EXTRACTED_FIELDS_VersionNumber: 'Numer wersji',
    EXTRACTED_FIELDS_Conditions: 'Warunki',
    EXTRACTED_FIELDS_NickName: 'Pseudonim',
    EXTRACTED_FIELDS_AddressApartmentNumber: 'Numer mieszkania',
    EXTRACTED_FIELDS_AddressFloorNumber: 'Numer Piętra',
    EXTRACTED_FIELDS_FirstNameLocal: 'Imię Lokalne',
    EXTRACTED_FIELDS_LastNameLocal: 'Nazwisko Lokalne',
    EXTRACTED_FIELDS_FullNameLocal: 'Pełne imię Lokalne',
    EXTRACTED_FIELDS_BirthPlaceLocal: 'Miejsce urodzenia lokalne',
    EXTRACTED_FIELDS_IssuingAuthorityLocal: 'Wydający organ lokalny',
    EXTRACTED_FIELDS_MotherNameLocal: 'Imię Matki Lokalne',
    EXTRACTED_FIELDS_FatherNameLocal: 'Imię ojca Miejscowe',
    EXTRACTED_FIELDS_AddressFullLocal: 'Adres Pełny Lokalny',
    EXTRACTED_FIELDS_MiddleNameLocal: 'Drugie Imię Lokalne',
    EXTRACTED_FIELDS_AddressLine1Local: 'Adres Linia1 Lokal',
    EXTRACTED_FIELDS_AddressLine2Local: 'Adres Linia 2 Lokal',
    EXTRACTED_FIELDS_AddressLine3Local: 'Adres Linia3 Lokal',
    EXTRACTED_FIELDS_IndRefNumber1: 'Numer referencyjny 1',
    EXTRACTED_FIELDS_IndRefNumber2: 'Numer referencyjny 2',
    EXTRACTED_FIELDS_IndRefNumber3: 'Numer referencyjny 3',
    EXTRACTED_FIELDS_IndRefNumber4: 'Numer referencyjny 4',
    EXTRACTED_FIELDS_IndRefNumber5: 'Numer referencyjny 5',
    EXTRACTED_FIELDS_Name1: 'Nazwa 1',
    EXTRACTED_FIELDS_Name2: 'Imię 2',
    EXTRACTED_FIELDS_Name3: 'Nazwa 3',
    EXTRACTED_FIELDS_Name4: 'Imię 4',
    EXTRACTED_FIELDS_Name5: 'Nazwa 5',
    EXTRACTED_FIELDS_RECIPIENT_NAME_1: 'Nazwa odbiorcy 1',
    EXTRACTED_FIELDS_RECIPIENT_NAME_2: 'Nazwa odbiorcy 2',
    EXTRACTED_FIELDS_RECIPIENT_NAME_3: 'Nazwa odbiorcy 3',
    EXTRACTED_FIELDS_RECIPIENT_NAME_4: 'Nazwa odbiorcy 4',
    EXTRACTED_FIELDS_RECIPIENT_ADDRESS_FULL: 'Adres odbiorcy Pełny',
    EXTRACTED_FIELDS_IBAN: 'Numer rachunku IBAN',
    EXTRACTED_FIELDS_ACCOUNT_NUM: 'Numer rachunku',
    EXTRACTED_FIELDS_ISSUER: 'Wydawca',
    EXTRACTED_FIELDS_RECIPIENT_ADDRESS_CITY: 'Adres odbiorcy Miejscowość',
    EXTRACTED_FIELDS_RECIPIENT_ADDRESS_POST_CODE: 'Adres odbiorcy Kod pocztowy',
    EXTRACTED_FIELDS_DAY: 'Dzień',
    EXTRACTED_FIELDS_MONTH: 'Miesiąc',
    EXTRACTED_FIELDS_YEAR: 'Rok',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_1: 'Wartość opcjonalna 1',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_2: 'Wartość opcjonalna 2',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_3: 'Wartość opcjonalna 3',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_4: 'Wartość opcjonalna 4',
    EXTRACTED_FIELDS_ISSUING_STATE_NAME: 'Nazwa państwa wydającego',
    EXTRACTED_FIELDS_FRONT_DOCUMENT_TYPE_ID:
        'Identyfikator typu dokumentu na awersie',
    EXTRACTED_FIELDS_BACK_DOCUMENT_TYPE_ID: 'Id typu dokumentu na odwrocie',
    HASNOCAMERA_TITLE:
        'Ups, nie mogliśmy rozpoznać kamery na Twoim urządzeniu!',
    HASNOCAMERA_DESCRIPTION:
        'Wygląda na to, że Twoje urządzenie nie ma kamery, spróbuj ponownie na innym urządzeniu, które ma działającą kamerę, abyś mógł wykonać wszystkie wymagane kroki.',
    EXTRACTED_FIELDS_COVIDPASSCROSSCHECKRESULT: 'Identyfikator typu Covid',
    USER_INPUT_FIRST_NAME: 'Imię',
    USER_INPUT_MIDDLE_NAME: 'Drugie imię',
    USER_INPUT_LAST_NAME: 'Nazwisko',
    USER_INPUT_DOB: 'Data urodzenia',
    USER_INPUT_HOUSE_NAME_NUMBER: 'Nazwa/numer domu*',
    USER_INPUT_STREET_NAME: 'Nazwa ulicy*',
    USER_INPUT_TOWN: 'Miejscowość*',
    USER_INPUT_POSTAL_CODE: 'Kod pocztowy*',
    USER_INPUT_HOUSE_NAME_NUMBER_EXAMPLE: 'np. Dom/35',
    USER_INPUT_STREET_NAME_EXAMPLE: 'np. Test Street',
    USER_INPUT_TOWN_EXAMPLE: 'np. Somewhere',
    USER_INPUT_POSTAL_CODE_EXAMPLE: 'np. CH496 (bez spacji)',
    SYSTEM_NOT_ABLE: 'System nie mógł zeskanować dokumentu',
    TRY_AGAIN: 'Spróbuj ponownie',
    HINTS_DISABLED_HEADER: 'Wskazówki są wyłączone w trybie ręcznym',
    HINTS_DISABLED_DESCRIPTION:
        'Jeśli chcesz włączyć wskazówki dotyczące robienia zdjęcia, przełącz się na tryb AUTOMATYCZNEGO PRZECHWYTYWANIA',
    YOU_HAVE: 'Masz',
    PICTURE_VERIFYING: 'Weryfikowanie...',
    HOW_TO_TAKE_PHOTO_CORRECTLY: 'Jak zrobić zdjęcie poprawnie',
};
